import { z } from 'zod';
import { idSchema } from '../common';

/**
 * Rubrica: vista trasversale, non un'entità nuova. È una UNION sulle
 * anagrafiche esistenti, con la categoria sempre esposta.
 */

export const CategoriaContatto = z.enum([
  'Cliente',
  'Persona cliente',
  'Partner',
  'Persona partner',
  'Utente',
]);
export type CategoriaContatto = z.infer<typeof CategoriaContatto>;

export const contattoSchema = z.object({
  categoria: CategoriaContatto,
  /** Id nell'entità di origine: unico solo nella coppia (categoria, id). */
  id: idSchema,
  /** Denominazione già composta per l'ordinamento alfabetico. */
  denominazione: z.string(),
  ruolo: z.string().nullable(),
  email: z.string().nullable(),
  telefono: z.string().nullable(),
  /** Azienda di appartenenza per le persone (cliente o partner). */
  appartenenza: z.string().nullable(),
  appartenenzaId: idSchema.nullable(),
});
export type Contatto = z.infer<typeof contattoSchema>;

export const rubricaQuerySchema = z.object({
  categoria: CategoriaContatto.optional(),
  q: z.string().trim().min(1).optional(),
});
export type RubricaQuery = z.infer<typeof rubricaQuerySchema>;
